import React from 'react'
import { setAuthorizationToken } from './storage'
import { GoogleLogin } from '@react-oauth/google'
import packoorangLoginIllustration from '../../assets/images/packoorangLoginIllustration.png'
import packoorangLogoText from '../../assets/images/packoorangLogoText.svg'
import { graphql } from '../../gql'
import { useMutation } from 'urql'

const UpdateLastLoginMutation = graphql(`
  mutation UpdateLastLoginMutation {
    updateLastLogin {
      user {
        id
        lastLogin
      }
    }
  }
`)

export const Login: React.FC = () => {
  const [, updateLastLogin] = useMutation(UpdateLastLoginMutation)

  return (
    <>
      <div className="flex-col-reverse flex sm:flex-row min-h-full flex-1 bg-gray-50">
        <div className="flex flex-1 flex-col bg-white justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <img
                className="h-6 sm:h-10 w-auto"
                src={packoorangLogoText}
                alt="Your Company"
              />
              <h2 className="mt-8 text-2xl font-bold leading-8 tracking-tight text-gray-900">
                Sign in to your account
              </h2>
            </div>

            <div className="mt-10 text-center">
              <GoogleLogin
                onSuccess={credentialResponse => {
                  const jwt = credentialResponse.credential

                  if (jwt) {
                    setAuthorizationToken(jwt)
                    updateLastLogin({}).finally(() => {
                      window.location.reload()
                    })
                  }
                }}
                onError={() => {
                  console.error('Login with Google failed.')
                }}
                useOneTap={true}
                auto_select={true}
              />
            </div>
          </div>
        </div>
        <div className="relative flex-1 flex flex-col justify-end items-center pb-0 sm:pb-[10vh] ">
          <img
            className="absolute top-0"
            src={packoorangLoginIllustration}
            alt=""
          />
          <div className={'flex flex-col items-center max-sm:mt-8'}>
            <span className="leading-6 text-base font-semibold text-gray-900">
              Packtrack
            </span>
            <span className={'leading-6 text-gray-700'}>
              A circular economy package tracking application
            </span>
          </div>
        </div>
      </div>
    </>
  )
}
